import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Input } from 'src/domains/common/components/input/input';
import { IconButton } from 'src/domains/common/components/button/icon-button';
import { SinglePromoCodeState } from 'src/domains/casino/webview/bonus-engine/campaign/promo-code/single-promo-code/SinglePromoCode.state';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { CampaignStore } from 'src/domains/casino/state/AppCasino/store/campaign-store/Campaign.store';
import { useAppStateContext } from 'src/AppState/AppState';

type SinglePromoCodePropsType = {
    promoCodeState: SinglePromoCodeState;
    campaignId: string | undefined;
    index: number;
};

export const SinglePromoCode = observer('SinglePromoCode', (props: SinglePromoCodePropsType) => {
    const { routerBackoffice } = useAppStateContext();
    const common = useCommon();
    const campaignCreatorState = CampaignCreatorState.get(common, props.campaignId);
    const campaignStore = CampaignStore.get(common);
    const { promoCodeState, index } = props;
    const campaignStatus = campaignCreatorState.campaign?.status;

    // TODO: All input validations info here -> https://playbookengineering.atlassian.net/wiki/spaces/Boen/pages/33243758664/SOL+DEF+-+Promo+Code#Promo-Code-Campaign-(II-Priority)

    const promoCodeStatusUpdateDisabled =
        campaignStatus === 'draft' ||
        campaignStatus === 'paused' ||
        campaignStatus === 'expired' ||
        routerBackoffice.bonusCampaignCloneIdParam !== null ||
        promoCodeState.isPromoCodeEmpty ||
        campaignStore.isPromoCodeUpdating;

    return (
        <div
            data-test={`promo-row-${index}`}
            className='grid w-full grid-cols-[5fr_5fr_1fr] gap-2'
        >
            <Input
                dataTest='promo-code'
                formInputState={promoCodeState.promoCodeName}
                errors={promoCodeState.promoCodeName.errorsForView}
                disabled={campaignCreatorState.editionDisabled}
            />
            <Input
                dataTest='use-limit'
                formInputState={promoCodeState.useLimit}
                errors={promoCodeState.useLimit.errorsForView}
                disabled={campaignCreatorState.editionDisabled}
            />
            <div className='flex gap-2'>
                {promoCodeState.isPaused === true ? (
                    <IconButton
                        dataTest='play-button'
                        icon='play'
                        onClick={() => promoCodeState.setPromoActive(props.campaignId)}
                        size='default'
                        title='Play'
                        variant='primary'
                        disabled={promoCodeStatusUpdateDisabled}
                    />
                ) : (
                    <IconButton
                        dataTest='pause-button'
                        icon='pause'
                        onClick={() => promoCodeState.setPromoInactive(props.campaignId)}
                        size='default'
                        title='Pause'
                        variant='outline'
                        disabled={promoCodeStatusUpdateDisabled}
                    />
                )}
                <IconButton
                    dataTest='delete-button'
                    icon='trash'
                    onClick={() => campaignCreatorState.promoCodesState.deletePromoCode(promoCodeState.id)}
                    size='default'
                    title='Delete'
                    variant='destructive'
                    disabled={campaignCreatorState.editionDisabled}
                />
            </div>
        </div>
    );
});
